export const markedareaTemplates = [
  { icon: "fa-heading", name: "Titel 1", text: "\n# Titel\n" },
  { icon: "fa-heading", name: "Titel 2", text: "\n## Titel\n" },
  { icon: "fa-heading", name: "Titel 3", text: "\n### Titel\n" },
  { icon: "fa-italic", name: "Italic", text: " *italic*" },
  { icon: "fa-bold", name: "Fett", text: " **fett**" },
  {
    icon: "fa-list",
    name: "Liste",
    text: "\n* Liste1\n* Liste2\n  * Liste21\n  * Liste22\n"
  },
  {
    icon: "fa-list-ol",
    name: "Num",
    text: "\n1. Liste1\n1. Liste2\n1. Liste3\n"
  },
  { icon: "fa-minus", name: "Linie", text: "\n\n---\n" },
  {
    icon: "fa-link",
    name: "Link",
    text:
      '\n[Beschriftung](https://www.google.com/ "Titel, der beim Überfahren mit der Maus angezeigt wird")\n'
  },
  {
    icon: "fa-table",
    name: "Tabelle",
    text:
      "\n| h1 | h2 | h3 |\n|:-|:-:|-:|\n| L00 | C01 | R02 |\n| L10 | C11 | R12 |"
  }
];

export const emptyJournalEntry = {
  timestamp: 0,
  journalType: "",
  email: "",
  firstName: "",
  lastName: "",
  phone: "",
  subject: "",
  text: "",
  tibTag: "",
  private: false
};

export const emptyNotificationUser = {
  email: "",
  firstName: "",
  lastName: "",
  activeUntil: null
};

export const TT_URL = "/tt";
export const loc = window.location;
export const baseUrl =
  loc.protocol + "//" + loc.hostname + ":" + loc.port + TT_URL;
export const BASE_PATH = "/servicekleber";

export const displayPage = {
  HOME: "home",
  CODE: "code",
  EDIT_JOURNAL_ENTRY: "editJournalEntry",
  TIBS: "tibs",
  LOGIN: "login",
  ADDRESS_LIST: "addressList",
  ADDRESS: "address",
  EDIT_SERVICEKLEBER: "editServicekleber",
  DOMAIN_JOURNAL: "domainJournal",
  TIB_JOURNAL: "tibJournal",
  NEW_QR_CODE: "newQrCode",
  SERVICEKLEBER_LIST: "alleServiceKleber",
  FAULT_REPORT: "faultReport",
  SCAN: "scan",
  ADMIN_TIMETRACKING: "adminTimetracking",
  TIME_TRACKING: "timeTracking",
  ERROR: "error"
};

export var lang = 0;

export const translation = {
  servicekleber: ["Servicekleber", "Apartment Sticker"],
  save: ["Speichern", "Save"],
  cancel: ["Abbrechen", "Cancel"],
  createNewAddress: ["Neue Adresse erfassen", "Create New Address"],
  createNewServicekleber: ["Neuen Kleber erfassen", "Create New Apartment"],
  name: ["Name", "Name"],
  description: ["Beschreibung", "Description"],
  floor: ["Stockwerk", "Floor"],
  popupMessage: ["Nachricht", "Message"],
  popupMessageHelp: [
    "Dieser Text erscheint beim Einscannen des QR Codes und wird verwendet, um auf eine aktuelle Information hinzuweisen.",
    "This text is used to inform about important things when QR code is scanned."
  ],
  address: ["Adresse", "Address"],
  tenant: ["Mandant", "Tenant"],
  city: ["Ort", "City"],
  extRef: ["Ext. Ref.", "Ext. Ref."],
  notify: ["Benachrichtigung", "Notify"],
  notifyHelp: [
    "Hier steht eine Komma-separierte Liste von Email Adressen, welche informiert werden, wenn ein neuer Journal Eintrag erfasst wird.",
    "List of comma-separated email addresses, which are notified on new journal entries. "
  ],
  size: ["Grösse", "Size"],
  version: ["Version", "Version"],
  email: ["Email", "Email"],
  password: ["Passwort", "Password"],
  domainAccount: ["Domäne", "Domain"],
  journal: ["Journal", "Journal"],
  login: ["Login", "Login"],
  logout: ["Abmelden", "Logout"],
  confirm: ["Bestätigen", "Confirm"],
  ok: ["OK", "OK"],
  tibs: ["Dokumente (TiBs)", "Documents (TiBs)"],
  file: ["Datei", "File"],
  edit: ["Bearbeiten", "Edit"],
  upload: ["Hochladen", "Upload"],
  browse: ["Durchsuchen", "Browse"],
  reload: ["Neu laden", "Relaod"],
  restrictedAccess: ["Eingeschränkt sichtbar", "Restricted Access"],
  enterCode: ["Code eingeben", "Enter Code"],
  home: ["Home", "Home"],
  newQrCodeDescription: [
    "Dieser QR Code {tag} ist noch keinem Gerät zugeordnet. Sie können diesen QR Code einem neuen Gerät zuordnen, oder Sie können den QR Code eines bestehenden Geräts ändern",
    "Create new QR code"
  ]
};

export const emptyAddress = {
  tib: null,
  data: {
    id: null,
    popupMessage: "",
    description: "",
    address: "",
    city: ""
  },
  servicekleber: [],
  nextServicekleberId: 1,
  tibs: []
};

export const emptyServicekleber = {
  address: null,
  tib: null,
  currentPage: displayPage.HOME,
  data: {
    id: null,
    subtitle: "",
    description: "",
    popupMessage: "",
    tenant: "",
    floor: "",
    extRef: "",
    deviceLocation: "",
    manufacturer: "",
    deviceName: "",
    deviceType: "",
    serialNumber: "",
    deviceNumber: ""
  },
  banner: null,
  images: [],
  tibs: []
};
